var React = require('react');

function ExecutiveVideoPath (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"executive-video","fill":"none","stroke":"rgb(9,31,42)","strokeLinecap":"butt","strokeLinejoin":"miter","strokeWidth":"2","d":"M1685.7046301 219.14595376s-334-289-630.5-196-361 544.5-602 590-435.5-93-448.5-158.5"}));
}

ExecutiveVideoPath.defaultProps = {"viewBox":"0 0 1690.409 626.851"};

module.exports = ExecutiveVideoPath;

ExecutiveVideoPath.default = ExecutiveVideoPath;
